import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  
  public registerForm: FormGroup;
  public submitted=false;
  showInvitationCode: boolean = false;

  public reconnecte=false;
  constructor(private formBuilder: FormBuilder, private router: Router, private authService : AuthService  ) {
}
errtext = '';
    ngOnInit(): void {
      this.registerForm = this.formBuilder.group({
        username: ["", [Validators.required]],
        email:["", [Validators.required,Validators.email]],
        tel:["", [Validators.required,Validators.minLength(8)]],
        password: ["",[Validators.required,Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*?[#?!@$%^&*-])[A-Za-z\d?=.*?[#?!@$%^&*-].{8,}'),Validators.minLength(8)]],
        invitationCode: [""],

        confirmpassword:["",
            Validators.required
            ]},
            
            { validators: this.matchpasswordd })

           
          };
        

     
  
    get formControl() {
      return this.registerForm.controls;
    }
    get tel(){
      return this.registerForm.get("tel")
    }
    get email(){
      return this.registerForm.get("email")
    }
   
    get username(){
      return this.registerForm.get("username")
    }
    get password(){
      return this.registerForm.get("password")
    }
   get confirmpassword(){
    return this.registerForm.get("confirmpassword")
    }
    get code(){
      return this.registerForm.get("invitationCode")
    }
    matchpasswordd(group: AbstractControl) {
      let pasword: string = group.get('password').value;
      let confirmPassword: string = group.get('confirmpassword').value;
      if (pasword.localeCompare(confirmPassword) != 0) {
          //error
          group.get('confirmpassword')?.setErrors({ mismatch: true });
          return { mismatch: true };
      } else {
          //no error, return null (don't return { mismatch: false })
          return null;
      }
  }
  toggleInvitationCode() {
    this.showInvitationCode = !this.showInvitationCode;
  }
   onredirect():void{
         this.onRegistre()
         //this.onvide()

   }
   onvide():void{
    this.registerForm['username']=""
    this.registerForm['email']=""
    this.registerForm['password']=""
    this.registerForm['confirmpassword']=""
  
  }
  onRegistre() {

    if (this.registerForm.valid) {
      console.log ('uuuuuuuuuuuu')
      console.log(this.registerForm.value)

      this.authService.signup(this.registerForm.value)
      .subscribe(data => {
        console.log (data , "data signup ")
       
        this.submitted = true
        this.errtext = 'Votre compte est crée .Veuillez vérifier votre email '
     
        this.reconnecte=true

        setTimeout(() => {
          this.router.navigate(['/']);
       }, 3000)
      
        
      }, 
      
      error => {

       

        console.log(error, 'error')
        if (error.status == 404) {
          this.errtext = 'utilisateur inexistant ! '
          console.log('not found ')
          this.reconnecte=false
        }
        else if (error.status == 401 || error.status==402) {
          this.errtext = error.error.message
          console.log('pwd incorrect  ')
          this.reconnecte=false

        }

      }
      
      )
   

    }


  }
 

}
